import Alert from '@material-ui/lab/Alert'
import { FormSlider } from './sections/FormSlider'
import React, { useContext, useState } from 'react'
import { createPortal } from 'react-dom'
import { FormMeta } from './sections/form-meta/FormMeta'
import { useGetBusiness } from '@marketing-milk/frontend'
import { SaveChanges } from './save-changes/SaveChanges'
import { leadCardContext } from './context/LeadCardContext'
import { LeadCardWizardProps } from './LeadCardWizard.types'
import { StartFromExistingForm } from './StartFromExistingForm'
import { LeadCardPreview } from '../lead-card-preview/LeadCardPreview'
import { LeadCardContextProvider } from './context/LeadCardContextProvider'
import { ServerError } from 'components/server-request/server-error/ServerError'

export function LeadCardWizard(props: LeadCardWizardProps) {
  return (
    <LeadCardContextProvider defaultLeadCard={props.defaultLeadCard} editable={!!props.onSave}>
      <LeadCardWizardComponent {...props} />
    </LeadCardContextProvider>
  )
}

function LeadCardWizardComponent({
  onSave,
  startFromForms,
  actionsContainer,
  onCancelCreation,
}: LeadCardWizardProps) {
  const [error, setError] = useState<Error>()
  const leadCard = useContext(leadCardContext)
  const business = useGetBusiness()

  return (
    <div className="grid grid-cols-1 items-start gap-6 sm:p-4 lg:grid-cols-[minmax(0,1fr)_24rem]">
      {error && <ServerError error={error} onClose={() => setError(undefined)} />}

      <form className="min-w-0 rounded-md border border-gray-200 bg-white p-2">
        <div className="p-2 sm:p-4">
          {startFromForms && <StartFromExistingForm forms={startFromForms} />}
          <FormMeta />
          <hr />
          <FormSlider />
          {!onCancelCreation && (
            <>
              <hr className="my-3" />
              <SaveChanges onSave={onSave} />
            </>
          )}
        </div>
      </form>

      <aside aria-label="Lead form preview" className="min-w-0 rounded-md bg-gray-100 p-4">
        <p className="mb-1 text-sm font-semibold text-gray-600">Form preview</p>
        <p className="mb-4 text-sm text-gray-500">Uses the image from your ad.</p>
        {!leadCard.editable && (
          <Alert elevation={2} variant="standard" severity="info" className="mb-4">
            You can't make changes to this lead card
          </Alert>
        )}
        <div className="mx-auto max-w-full" style={{ width: 340 }}>
          <LeadCardPreview
            business={business}
            leadCard={leadCard}
            section={leadCard.previewSection}
            setSection={leadCard.setPreviewSection}
          />
        </div>
      </aside>
      {onCancelCreation &&
        actionsContainer &&
        createPortal(
          <SaveChanges
            onSave={onSave}
            label="Create form & add to batch"
            onCancel={onCancelCreation}
          />,
          actionsContainer
        )}
    </div>
  )
}
